export const translationEn = {
    "app_name": "CTXPRESS",
    "home": "Home",
    "individuals": "Individuals",
    "retailers": "Retailers",
    "become_a_helper": "Become a helper",
    "book_delivery": "Book a delivery",
    "loading": "Loading",
    "photo_header_title": "Here to do the heavy lifting.",
    "photo_header_text": "Nationwide, on-demand truck and muscle to move just about anything.",
    "get_a_quote": "Get a quote",
    "feature_title_1": "Apartment moves",
    "feature_text_1": "Entire apartment or just the big stuff",
    "feature_title_2": "Store delivery",
    "feature_text_2": "Same-day delivery from any store",
    "feature_title_3": "Truck & muscle",
    "feature_text_3": "Haul away, small moves, and more",
    "learn_more": "Learn more",
    "explore_partnership": "Explore partnership",
    "service_title_1": "The final-mile delivery leader for retailers of all sizes.",
    "service_text_1": "Boost sales and scale your business with nationwide, same-day and scheduled delivery.",
    "income_title_1": "Start earning with Delivery. ",
    "income_text_1": "Build your own delivery business.",
    "income_action_1": "Earn $50/hr on average",
    "email": "Email",
    "email_placeholder": "someone@email.com",
    "username": "Username",
    "username_placeholder": "Input your username",
    "password": "Password",
    "password_placeholder": "Input your password",
    "retype": "Verify",
    "retype_placeholder": "Retype your password",
    "login": "Login",
    "signup": "Sign Up",
    "remember_me": "Remember Me",
    "forgot_password": "Forgot Password",
    "send_reset_email": "Send Password Reset Email",
    "input_email_prompt": "You should input valid email address",
    "input_username_prompt": "You should input valid username",
    "input_password_prompt": "You should input valid password with at least 4 letters",
    "input_retype_prompt": "Password verifying string not matching",
    "reset_password_success": "Password reset email sent.",
    "reset_password_failure": "Failed to send password reset email",
    "auth_success": "User authenticated successfully",
    "auth_failure": "User authentication failed",
    "book_delivery_title": "Book a Delivery",
    "requred_fields_notation": "All fields required unless otherwise noted.",
    "customer_information": "Customer information",
    "firstname": "First Name",
    "firstname_placeholder": "Input your first name",
    "lastname": "Last Name",
    "lastname_placeholder": "Input your last name",
    "phone": "Phone Number",
    "phone_placeholder": "Input your phone number",
    "customer_note": "Note: Email & phone numbers are used to inform customers of delivery status. If either exist in our system already, we use the original record instead.",
    "locations": "Locations",
    "your_store": "Your store",
    "store_address": "Pick up Address",
    "store_name": "Store Name",
    "drop_off_address": "Drop-off address",
    "add_dropoff": "+ Add a drop off location",
    "items": "Items",
    "add_item": "+ Add Item",
    "this_is_store": "This is a store",
    "unit_number": "Unit or apartment number",
    "need_stairs": "Stairs",
    "hardwood_floors": "Has hardwood floors",
    "parking_info": "Parking and building info",
    "add_an_item": "Add an item",
    "add_item_note": "Select a popular item from this store",
    "helpers": "Helpers",
    "enter_item": "Enter an item",
    "item_helper_count": "Helper Count",
    "create_item": "Create an Item",
    "close": "Close",
    "add_order_id": "Add Order ID",
    "order_id": "Order No",
    "add_hfc_id": "Add HFC Id",
    "hfc_id": "HFC Id",
    "order_id_placeholder": "Enter Sales Order no.",
    "hfc_id_placeholder": "Enter HFC id.",
    "date_time": "Date & Time",
    "payment": "Payment",
    "dashboard": "Dashboard",
    "deliveries": "Deliveries",
    "deliveries_completed": "Completed Deliveries",
    "delivery_completed": "Delivery completed",
    "delivery_not_completed": "Delivery not completed",
    "stores": "Stores",
    "name": "Name",
    "address": "Address",
    "create": "Create",
    "save": "Save",
    "edit": "Edit",
    "details": "Details",
    "cancel": "Cancel",
    "store_number": "Store Number",
    "change_success": "Data Change Uploaded Successfully.",
    "change_failure": "Data Change Update Failed.\n",
    "book_success": "Delivery Booked Successfully.",
    "book_failure": "Booking Delivery Failed.\n",
    "customer": "Customer",
    "store": "Store",
    "pick_store": "Pick Store",
    "how_many": "How many?",
    "book_date_title": "When will the order be ready for pick up?",
    "book_date_text": "The customer will be able to schedule the delivery on a later day if necessary.",
    "book_date_text_details": "This customer wants to schedule the delivery on date below",
    "book_date": "Del date 1",
    "book_date_label": "Delivery date",
    "book_time_label": "Delivery Time",
    "book_time_1_label": "Another Delivery Time",
    "full_assembly_title": "Add full Assembly for $25",
    "full_assembly_label": "Assembly Item",
    "full_assembly_text": "This item is eligible for full assembly. Please have assembly instructions ready for your Helper, and add any additional information in the Optional Details below",
    "breakdown_title": "Requires Breakdown to Move",
    "breakdown_text": "This is something that needs to be broken down and then reassembled after moving. if there are any special tools required please add in the Optional Details below",
    "add_photo_prompt": "If available, please add a photo receipt. Receipts help ensure our Helpers collect the right items.",
    "add_photo": "+ Add a Photo",
    "add_item_photo_prompt": "Please take pictures of the item front, back, top and bottom",
    "missing_item_photo_prompt": "You should take at least 4 pictures of the item you want to add",
    "add_item_photo": "+ Add a Photo",
    "item_photos": "Item Photos",
    "receipt_photo": "Receipt Photo",
    "add_optional_details": "+ Add Optional Details",
    "no_customer_data": "You should fill out customer data first.",
    "no_location": "You should pick the store and fill out drop off locations first.",
    "no_items": "You should add at least one item.",
    "no_order_id": "You should input a valid order id.",
    "take_photo": "Take A Photo",
    "take_receipt_photo": "Take a picture of the receipt",
    "take_item_photo": "Take a picture of the item",
    "width_placeholder": "Width (in.)",
    "height_placeholder": "Height (in.)",
    "depth_placeholder": "Depth (in.)",
    "weight_placeholder": "What do you think this weights? (lbs.)",
    "other_placeholder": "Please include anything else your Helper should know",
    "optional_notes": "Optional notes",
    "optional_notes_prompt": "Any special instructions for the helper(s) on this delivery?",
    "total_distance": "Total distance",
    "price": "Price",
    "pick_store_prompt": "You should pick store from the list by pressing Pick Store button",
    "np_deadline": "You should pick delivery date and time first.",
    "invalid_date_prompt": "You should pick date later than today.",
    "title": "Title",
    "delivery_detail": "Delivery Record Details",
    "index": "Item Index",
    "item_id": "Item Id",
    "invalid_deadline_0": "You can not pick time earlier than now",
    "invalid_deadline": "You can not pick ending time earlier than the start time for delivery",
    "clear": "Clear",
    "invalid_customer_email": "You should input valid customer email address.",
    "logout": "Logout",
    "delete": "Delete",
    "delivery_date_filter": "Delivery Date Range",
    "start": "From",
    "end": "To",
    "_": "_",
}
